const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/uster/eCheckin/sections/Behandlungsvereinbarung.tsx';
import React, { forwardRef } from 'react';
import { useIntl } from 'react-intl';
import { useText } from '@cistec/common_web/utils/intlUtils';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { CIS4mSingleCheckbox } from '@cistec/common_web/modules/CIS4m/components/CIS4mSingleCheckbox';
import textMap from 'App/config/uster/eCheckin/translations';
import { createFieldPath } from 'App/components/eCheckin/utils';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import { ECheckinSectionProps } from 'App/components/eCheckin/types';
import { YesNoField } from 'App/components/eCheckin/components/fields/YesNoField';
import { LabelLink } from 'App/components/eCheckin/components/fields/LabelLink';

export const Behandlungsvereinbarung = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);

    const PATH_COSTS_AND_CONSENT = createFieldPath(path, 'costsAndConsent');
    const PATH_COSTS_AND_CONSENT_DATA = createFieldPath(path, 'costsAndConsentData');
    const PATH_PRIVACY_POLICY = createFieldPath(path, 'privacyPolicy');

    const { formatMessage } = useIntl();
    const eCheckinSectionRef = useCIS4m(ref);

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={path} title={title}>
            <h1>{title}</h1>
            <div dangerouslySetInnerHTML={{ __html: formatMessage(textMap.costsAndConsentText) }} />
            <YesNoField
                label={textMap.costsAndConsentData}
                path={PATH_COSTS_AND_CONSENT_DATA}
                required={true}
                yesValue="yes"
                noValue="no"
            />
            <CIS4mSingleCheckbox
                label={formatMessage(textMap.costsAndConsentCheckbox, {
                    link: (
                        <LabelLink
                            text={textMap.costsAndConsentLink}
                            url="https://www.spitaluster.ch/Aufenthalt/Aufenthalt-von-A-Z.16.html?scrollTo=Kosten"
                        />
                    ),
                })}
                path={PATH_COSTS_AND_CONSENT}
                required={true}
            />
            <CIS4mSingleCheckbox
                label={formatMessage(textMap.privacyPolicyCheckbox, {
                    link: (
                        <LabelLink
                            text={textMap.privacyPolicyLink}
                            url="https://www.spitaluster.ch/Ueberuns/Datenschutzerklaerung.962.html"
                        />
                    ),
                })}
                path={PATH_PRIVACY_POLICY}
                required={true}
            />
        </ECheckinSection>
    );
});

Behandlungsvereinbarung.displayName = 'Behandlungsvereinbarung';

export default Behandlungsvereinbarung;
